import "./style.css";

export default class ArticlesArchive {
  static selector = ".article-grid";

  constructor(block) {
    this.block = block;
  }
}
